"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationFilter = void 0;
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const messages_1 = require("../lib/messages");
const utils_1 = require("../lib/utils");
const styles_1 = require("../styles");
exports.LocationFilter = (0, intl_1.injectIntl)(({ disabled, intl, locations, log, onChange, selectedLocation }) => {
    const handleLocationChange = (location) => {
        let loggedLocation = {};
        if (location) {
            loggedLocation = { name: location.name, id: location.id };
        }
        (0, utils_1.logAppointmentInfoChange)(log, 'location', Object.assign({}, loggedLocation));
        onChange(location);
    };
    return (react_1.default.createElement(styles_1.LocationSelect, { id: "location-filter", inputProps: {
            'data-testid': 'availability-location-filter'
        }, label: intl.formatMessage(messages_1.messages.locationLabel), placeholder: intl.formatMessage(messages_1.messages.locationPlaceholder), items: locations, itemToString: (location) => {
            if (location) {
                const { name, phone, state, street1, street2, suite, zip, city } = location;
                return intl.formatMessage(messages_1.messages.locationSelection, {
                    name,
                    phone,
                    state,
                    street1,
                    street2,
                    suite,
                    zip,
                    city
                });
            }
            else {
                // appease the linter. if purpose is cleared between renders (e.g. if default purpose is disabled
                // via config and user changes relationship), option can be null between renders
                return '';
            }
        }, maxHeight: 200, selectedItem: selectedLocation, onChange: handleLocationChange, onClear: handleLocationChange, disabled: disabled }));
});
//# sourceMappingURL=LocationFilter.js.map